import { _adapters } from 'chart.js';
import React from 'react';

function QueueImputs(props) {
  const { changeValues, queue, moh, queueName } = props;
  const { [queueName]: { name, music, strategy, maxlen, ringinuse, announcePosition, announceFrequency, announceHoldTime, wrapuptime, minAnnounceFrequency, joinempty, leavewhenempty, timeout }} = queue;

  return (
    <div>
      <h2 style={{fontSize: '1.25rem', fontWeight: '600', color: '#2c3e50', marginBottom: '1.5rem'}}>{name}</h2>

      <div className="form-row">
        <div className="form-field form-field-large">
          <label className="form-label">Música</label>
          <div className="form-control">
            <select className="form-select" name="music" defaultValue={music} onChange={(e) => changeValues(e.target)}>
              <option value="">Selecione</option>
              <option value="default">Padrão</option>
              {moh.map((moh) => <option key={`${moh.name}`} value={moh.name}>{moh.name}</option>)}
            </select>
            <p name="music-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>

        <div className="form-field form-field-medium">
          <label className="form-label">Estratégia</label>
          <div className="form-control">
            <select className="form-select" name="strategy" defaultValue={strategy} onChange={(e) => changeValues(e.target)}>
              <option value="">Selecione</option>
              <option value="ringall">Tocar Todos</option>
              <option value="linear">Linear</option>
              <option value="random">Aleatório</option>
              <option value="rrmemory">Crescente</option>
              <option value="leastrecent">Ocioso</option>
              <option value="fewestcalls">Estatística</option>
            </select>
            <p name="strategy-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>

        <div className="form-field form-field-small">
          <label className="form-label">Segunda Chamada</label>
          <div className="form-control">
            <select className="form-select" name="ringinuse" defaultValue={ringinuse} onChange={(e) => changeValues(e.target)}>
              <option value="">Selecione</option>
              <option value="yes">Sim</option>
              <option value="no">Nao</option>
            </select>
            <p name="ringinuse-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>

        <div className="form-field form-field-small">
          <label className="form-label">Descanso</label>
          <div className="form-control">
            <input className="form-input" name="wrapuptime" defaultValue={wrapuptime} type="number" onChange={(e) => changeValues(e.target)} placeholder="3" />
            <p name="wrapuptime-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>

        <div className="form-field form-field-small">
          <label className="form-label">Mínimo</label>
          <div className="form-control">
            <input className="form-input" name="minAnnounceFrequency" defaultValue={minAnnounceFrequency} type="number" onChange={(e) => changeValues(e.target)} placeholder="35" />
            <p name="minAnnounceFrequency-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>

        <div className="form-field form-field-small">
          <label className="form-label">Freq.</label>
          <div className="form-control">
            <input className="form-input" name="announceFrequency" defaultValue={announceFrequency} type="number" onChange={(e) => changeValues(e.target)} placeholder="35" />
            <p name="announceFrequency-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>
      </div>

      <div className="form-row">
        <div className="form-field form-field-small">
          <label className="form-label">Anúncio Posição Fila</label>
          <div className="form-control">
            <select className="form-select" name="announcePosition" defaultValue={announcePosition} onChange={(e) => changeValues(e.target)}>
              <option value="">Selecione</option>
              <option value="yes">Sim</option>
              <option value="no">Nao</option>
            </select>
            <p name="announcePosition-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>

        <div className="form-field form-field-small">
          <label className="form-label">Anún. Tempo Estimado</label>
          <div className="form-control">
            <select className="form-select" name="announceHoldTime" defaultValue={announceHoldTime} onChange={(e) => changeValues(e.target)}>
              <option value="">Selecione</option>
              <option value="yes">Sim</option>
              <option value="no">Nao</option>
            </select>
            <p name="announceHoldTime-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>

        <div className="form-field form-field-small">
          <label className="form-label">Entrar (Se Vazia)</label>
          <div className="form-control">
            <select className="form-select" name="joinempty" defaultValue={joinempty} onChange={(e) => changeValues(e.target)}>
              <option value="">Selecione</option>
              <option value="yes">Sim</option>
              <option value="no">Nao</option>
              <option value="strict">Restrito</option>
            </select>
            <p name="joinempty-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>

        <div className="form-field form-field-small">
          <label className="form-label">Sair (Se Vazia)</label>
          <div className="form-control">
            <select className="form-select" name="leavewhenempty" defaultValue={leavewhenempty} onChange={(e) => changeValues(e.target)}>
              <option value="">Selecione</option>
              <option value="yes">Sim</option>
              <option value="no">Nao</option>
              <option value="strict">Restrito</option>
            </select>
            <p name="leavewhenempty-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>

        <div className="form-field form-field-small">
          <label className="form-label">Chamadas</label>
          <div className="form-control">
            <input className="form-input" name="maxlen" defaultValue={maxlen} type="number" onChange={(e) => changeValues(e.target)} placeholder="35" />
            <p name="maxlen-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>

        <div className="form-field form-field-small">
          <label className="form-label">Tempo de transbordo</label>
          <div className="form-control">
            <input className="form-input" name="timeout" defaultValue={timeout} type="number" onChange={(e) => changeValues(e.target)} placeholder="" />
            <p name="timeout-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QueueImputs;
